/**
 * 降级标记组件
 * ⚠️ 表示当前使用替代方案
 */

import React from 'react';
import styles from './badge.module.css';

interface DegradedBadgeProps {
  /** 提示信息 */
  message?: string;
  /** 是否显示 */
  show?: boolean;
}

/**
 * 降级标记
 * 当功能使用降级方案时显示
 */
export const DegradedBadge: React.FC<DegradedBadgeProps> = ({
  message,
  show = true,
}) => {
  if (!show) return null;

  return (
    <span className={styles.degraded} title={message}>
      ⚠️
    </span>
  );
};
